import {
	COMPONENT_CONNECTED,
	COMPONENT_DISCONNECTED,
	COMPONENT_BOOTSTRAPPED,
	COMPONENT_RENDERED,
	COMPONENT_DOM_READY,
	COMPONENT_PROPERTY_CHANGED,
	COMPONENT_PROPERTY_UPDATE_REQUESTED,
	COMPONENT_RENDER_REQUESTED,
	COMPONENT_DOM_TREE_READY,
	COMPONENT_TREE_RENDERED,
	COMPONENT_STATE_UPDATED,
	COMPONENT_INTERACTIVE
} from '../../constants';

const actions = {
	COMPONENT_CONNECTED,
	COMPONENT_DISCONNECTED,
	COMPONENT_BOOTSTRAPPED,
	COMPONENT_RENDERED,
	COMPONENT_DOM_READY,
	COMPONENT_PROPERTY_CHANGED,
	COMPONENT_PROPERTY_UPDATE_REQUESTED,
	COMPONENT_RENDER_REQUESTED,
	COMPONENT_DOM_TREE_READY,
	COMPONENT_TREE_RENDERED,
	COMPONENT_STATE_UPDATED,
	COMPONENT_INTERACTIVE
};

export function getActionsToDispatch(interceptors) {
	const shouldDispatch = {};

	for (const k in actions) {
		const type = actions[k];
		const intercpetorsByType = interceptors[type];
		if (intercpetorsByType && intercpetorsByType.has('host')) shouldDispatch[type] = true;
	}

	return shouldDispatch;
}
